import { ComponentTheme } from "hardcover-ui/types/base";

export type CalloutThemeProps = {
  variant: "primary" | "secondary";
  size: "md" | "lg";
};

const calloutBaseStyles = "mb-4 rounded-md bg-accent text-accent-foreground";

export const calloutTheme: ComponentTheme<CalloutThemeProps> = {
  variant: {
    primary: calloutBaseStyles,
    secondary: "bg-card text-secondary-foreground rounded-lg",
  },
  size: {
    md: "p-2 lg:p-4",
    lg: "p-4 md:p-6",
  },
};
